import { z } from 'zod';
import { ActionSchema } from '../actions';

export const RatingBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('rating'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({
    prompt: z.string().min(1),
    scale: z.union([z.literal(3), z.literal(5), z.literal(10)]),
    style: z.enum(['stars', 'faces', 'numbers'])
  })
});